import React from "react";
import PropTypes from "prop-types";
import ProfilePicture from "@govlaunch/profile-picture";
import * as Yup from "yup";
import Tag, { TagClose, TagText } from "./Tag";
import Alert from "./icons/Alert";
import * as palette from "@govlaunch/palette";
import noop from "lodash/fp/noop";
import { Toggle, Value } from "react-powerplug";
import Popover from "@govlaunch/popover";
import Link from "./icons/Link";
import DelayedMount from "./DelayedMount";
import RawButton from "./RawButton";
import { Mobile, MobileScreen, MobileScreenHeader, MobileScreenBody, Button, Input } from "@govlaunch/core";

export default function NewProductTag({ onChange, product, onClose, selected }) {
  return (
    <Mobile>
      {isMobile => (
        <Toggle>
          {({ on: isOpen, set: setOpen, toggle }) => (
            <Popover
              placement="bottom"
              onClickOutside={() => {
                if (isMobile) {
                  return;
                }
                setOpen(false);
              }}
              isOpen={isOpen}
              borderColor={palette.lightestGray}
              boxStyle={{
                boxShadow: "-2px 5px 20px 1px rgba(0, 0, 0, 0.1)",
              }}
              render={() => {
                return (
                  <Value initial={product.url}>
                    {({ value: inputValue, set: onInputChange }) => {
                      if (isMobile) {
                        return (
                          <MobileScreen isOpen={true}>
                            <MobileScreenHeader
                              onRequestClose={() => {
                                toggle();
                              }}
                            >
                              Add this product to Govlaunch!
                            </MobileScreenHeader>

                            <MobileScreenBody>
                              <Input
                                autoFocus={true}
                                backgroundColor="#fff"
                                backgroundClip="padding-box"
                                width="100%"
                                borderRadius={4}
                                padding="0 20px"
                                css={{
                                  "::placeholder": {
                                    color: palette.sealBlue,
                                  },
                                  ":focus": {
                                    border: `1px solid ${palette.darkSkyBlue}`,
                                    color: palette.darkGray,
                                    boxShadow: "none",
                                  },
                                  ":hover": {
                                    boxShadow: "none",
                                  },
                                }}
                                outline={0}
                                height={42}
                                color={palette.mediumGray}
                                boxShadow="none"
                                fontWeight={500}
                                value={inputValue || ""}
                                onChange={e => onInputChange(e.target.value)}
                                onKeyDown={e => {
                                  if (e.key === "Escape") {
                                    e.target.blur();
                                  }

                                  if (e.key === "Enter") {
                                    e.preventDefault();

                                    let actualUrl = inputValue;

                                    if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                      actualUrl = `http://${actualUrl}`;
                                    }

                                    if (isValidUrl(actualUrl)) {
                                      onChange({
                                        ...product,
                                        url: actualUrl,
                                      });
                                    } else {
                                      onChange(product);
                                    }
                                  }
                                }}
                                placeholder="Paste a link to this product"
                                name="url"
                              />

                              <div
                                css={{
                                  marginTop: 15,
                                  display: "flex",
                                }}
                              >
                                <div
                                  css={{
                                    width: "100%",
                                    marginRight: 15,
                                  }}
                                >
                                  <Button
                                    flex={1}
                                    width="100%"
                                    theme="primary"
                                    color={palette.greenSuccess}
                                    textColor={palette.white}
                                    type="button"
                                    onClick={() => {
                                      let actualUrl = inputValue;

                                      if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                        actualUrl = `http://${actualUrl}`;
                                      }

                                      if (isValidUrl(actualUrl)) {
                                        onChange({
                                          ...product,
                                          url: actualUrl,
                                        });
                                      } else {
                                        onChange(product);
                                      }
                                    }}
                                  >
                                    Add Product
                                  </Button>
                                </div>
                                <Button
                                  flex={1}
                                  width="100%"
                                  theme="secondary"
                                  color={palette.greenSuccess}
                                  onClick={() => {
                                    toggle();
                                  }}
                                  type="button"
                                >
                                  Cancel
                                </Button>
                              </div>
                            </MobileScreenBody>
                          </MobileScreen>
                        );
                      }

                      return (
                        <div
                          css={{
                            display: "flex",
                            flexDirection: "column",
                            padding: 25,
                            minWidth: 515,
                          }}
                        >
                          <div
                            css={{
                              marginBottom: 15,
                            }}
                          >
                            <p
                              css={{
                                margin: 0,
                                fontSize: 16,
                                color: palette.text,
                              }}
                            >
                              Add this product to the Govlaunch platform!
                            </p>
                          </div>
                          <DelayedMount delay={5}>
                            <Input
                              autoFocus={true}
                              leftIcon={<Link />}
                              value={inputValue || ""}
                              onChange={e => onInputChange(e.target.value)}
                              onKeyDown={e => {
                                if (e.key === "Escape") {
                                  e.target.blur();
                                }

                                if (e.key === "Enter") {
                                  e.preventDefault();

                                  let actualUrl = inputValue;

                                  if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                    actualUrl = `http://${actualUrl}`;
                                  }

                                  if (isValidUrl(actualUrl)) {
                                    onChange({
                                      ...product,
                                      url: actualUrl,
                                    });
                                  } else {
                                    onChange(product);
                                  }
                                }
                              }}
                              placeholder="Paste a link to this product"
                              name="url"
                            />
                          </DelayedMount>
                          <div
                            css={{
                              marginTop: 15,
                              display: "flex",
                            }}
                          >
                            <div
                              css={{
                                width: "100%",
                                marginRight: 15,
                              }}
                            >
                              <Button
                                theme="primary"
                                color={palette.greenSuccess}
                                textColor="#fff"
                                type="button"
                                onClick={() => {
                                  let actualUrl = inputValue;

                                  if (!/(http:\/\/|https:\/\/)/.test(actualUrl)) {
                                    actualUrl = `http://${actualUrl}`;
                                  }

                                  if (isValidUrl(actualUrl)) {
                                    onChange({
                                      ...product,
                                      url: actualUrl,
                                    });
                                  } else {
                                    onChange(product);
                                  }
                                }}
                              >
                                Add Product
                              </Button>
                            </div>
                            <Button
                              color={palette.greenSuccess}
                              theme="secondary"
                              success={true}
                              onClick={toggle}
                              type="button"
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      );
                    }}
                  </Value>
                );
              }}
            >
              {({ innerRef }) => (
                <Tag
                  onClose={onClose}
                  css={{
                    maxWidth: 255,
                    height: 48,
                    paddingLeft: 15,
                    paddingRight: 15,
                  }}
                  selected={selected}
                  highlighted={Boolean(isOpen)}
                >
                  <div
                    css={{
                      marginRight: 10,
                      display: "inline-flex",
                    }}
                  >
                    <ProfilePicture name={product.name} image={product.logo} size={25} />
                  </div>
                  <TagText
                    css={{
                      color: palette.text,
                      fontWeight: 500,
                      fontSize: 12,
                      textTransform: "uppercase",
                    }}
                  >
                    {product.name}
                  </TagText>
                  <RawButton
                    type="button"
                    onClick={toggle}
                    tabIndex={0}
                    css={{
                      cursor: "pointer",
                      outline: 0,
                    }}
                    aria-label="Toggle product popover"
                    innerRef={innerRef}
                  >
                    <Alert />
                  </RawButton>
                  {onClose && (
                    <RawButton
                      tabIndex={0}
                      type="button"
                      onClick={onClose}
                      aria-label="Remove product"
                      css={{
                        marginLeft: 10,
                      }}
                    >
                      <TagClose />
                    </RawButton>
                  )}
                </Tag>
              )}
            </Popover>
          )}
        </Toggle>
      )}
    </Mobile>
  );
}

NewProductTag.propTypes = {
  product: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  selected: PropTypes.bool,
};

NewProductTag.defaultProps = {
  onClose: noop,
  onChange: noop,
  selected: false,
};

function isValidUrl(url) {
  return Yup.string()
    .url()
    .isValidSync(url);
}
